"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var buttonSubmitStyles = makeStyles_1.default(function (_a) {
    var _b;
    var palette = _a.palette, typography = _a.typography, breakpoints = _a.breakpoints;
    return ({
        submitButtonContainer: (_b = {
                display: 'block',
                float: 'right',
                margin: '20px 0'
            },
            _b[breakpoints.down(breakpoints.values.sm)] = {
                float: 'unset',
                display: 'flex',
                justifyContent: 'center',
            },
            _b),
        btnContained: {},
        submitButton: {
            color: palette.common.white,
            textTransform: 'capitalize',
            width: '100%',
            marginLeft: 0,
            '& > span': {
                fontSize: typography.fontMD,
            },
        },
        newContainedPrimary: {},
    });
}, { name: 'GqlCheckout_InStorePaymentForm_ButtonSubmit' });
exports.default = buttonSubmitStyles;
